/**
 * Read-only workout template access for scheduled session prescriptions.
 */
import { http } from "@/lib/api";

const ROOT = "/workout-library/template";
const LIBRARY = "/workout-library";

export const fetchWorkoutTemplate = async ({
  workoutCode,
  templateVersion,
  signal,
}) => {
  if (!workoutCode) return null;
  const params = templateVersion ? { template_version: templateVersion } : undefined;
  const { data } = await http.get(
    `${ROOT}/${encodeURIComponent(workoutCode)}`,
    { params, signal },
  );
  return data;
};

export const fetchWorkoutLibrary = async (sport, { signal } = {}) => {
  const { data } = await http.get(`${LIBRARY}/${encodeURIComponent(sport)}`, { signal });
  return data?.templates || [];
};

export const useCustomizedWorkout = async ({
  workoutCode,
  requestedDurationMinutes,
  difficulty,
}) => {
  const { data } = await http.post(`${LIBRARY}/use`, {
    workout_code: workoutCode,
    requested_duration_minutes: requestedDurationMinutes,
    difficulty,
  });
  return data;
};

export const previewWorkoutAdaptation = async ({
  workoutCode,
  requestedDurationMinutes,
  difficulty,
}) => {
  const { data } = await http.post(`${LIBRARY}/adapt`, {
    workout_code: workoutCode,
    requested_duration_minutes: requestedDurationMinutes,
    difficulty,
  });
  return data;
};

export const downloadWorkoutZwo = async ({ name, sport, warmup, main_set, cooldown }) => {
  const response = await http.post(`${LIBRARY}/export-zwo`, {
    name,
    sport,
    warmup,
    main_set,
    cooldown,
  }, { responseType: "blob" });
  const header = response.headers?.["content-disposition"] || "";
  const match = header.match(/filename="([^"]+)"/);
  return { blob: response.data, filename: match?.[1] || "workout.zwo" };
};
